import { AmountSkeleton } from 'components/shared/Amount/Amount';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const DealSplitGridSkeleton: FC = () => (
  <div data-e2e="deal-splits-container" className="dealsplits">
    <table className="table table-sm table-bordered mb-0">
      <thead>
        <tr>
          <th className="collapsable-cell">
            <Skeleton />
          </th>
          <th className="collapsable-cell">
            <Skeleton />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <AmountSkeleton />
          </td>
          <td>
            <AmountSkeleton />
          </td>
        </tr>
      </tbody>
    </table>
    <div className="mt-3 d-flex w-100">
      <span className="p-2">
        <Skeleton width="1em" />
        <span className="ms-2">
          <Skeleton width="7em" />
        </span>
      </span>
      <span className="flex-grow-1"></span>
      <div className="form-group row small ">
        <label htmlFor="dealSplit-unallocatedAmount" className="col-form-label">
          <Skeleton width="7em" />
        </label>
        <div className="with-unit-component input-group pe-1 me-2" data-e2e="dealSplit-unallocatedAmount-with-unit">
          <div className="input-group-text">
            <Skeleton width="3em" />
          </div>
          <AmountSkeleton />
        </div>
      </div>
    </div>
  </div>
);
